import _ from 'lodash';
import React, { Component } from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';

import BookingListItem from '../BookingListItem/BookingListItem';

import './BookingList.css';

class BookingList extends Component {
  static get propTypes() {
    return { bookings: PropTypes.array.isRequired };
  }

  render() {
    return (
      <div className="BookingList">
        {this.props.bookings.map(booking => {
          return <BookingListItem booking={booking} key={booking.id} />;
        })}
      </div>
    );
  }
}

export default BookingList;



// WEBPACK FOOTER //
// ./src/components/BookingList/BookingList.js